import { LocaleContext } from "../contexts/LocaleContext";
import { useContext, useEffect, useRef, useState } from "react";
import logo from "../assets/images/logo_white.png";
import Notification from "./Notification";
import { useAuth } from "../hooks/useAuth";
import { useNotification } from "../hooks/useNotification";
import LogoutConfirmation from "./LogoutConfirmation";
import tokenService from "../services/tokenService";

const Header = () => {
  const { t, lang, changeLanguage } = useContext(LocaleContext);
  const { logout } = useAuth();
  const { unreadCount, decrementCount } = useNotification();
  const [showNotifications, setShowNotifications] = useState(false);
  const panelRef = useRef(null);
  const providerName = tokenService.getFullName();

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (panelRef.current && !panelRef.current.contains(e.target)) {
        setShowNotifications(false);
      }
    };
    if (showNotifications)
      document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showNotifications]);

  return (
    <>
      <input type="checkbox" id="aside-toggle" className="aside-toggle" />
      <header>
        <nav>
          <ul>
            <li>
              <div className="brand-logo-box">
                <label
                  htmlFor="aside-toggle"
                  className="fa-solid fa-bars"
                ></label>
                <img src={logo} alt="Logo" />
              </div>
            </li>
            <li>
              <div className="input-icon">
                <input
                  type="text"
                  className="form-control input-search"
                  placeholder={t("search")}
                />
                <i className="fas fa-search"></i>
              </div>
            </li>
          </ul>
          <ul className="header-icons">
            <li style={{ position: "relative" }}>
              <i
                className="fas fa-bell text-white cursor-pointer"
                onClick={() => setShowNotifications((prev) => !prev)}
              ></i>
              {unreadCount > 0 && (
                <span
                  style={{
                    position: "absolute",
                    top: "-12px",
                    right: "-5px",
                    background: "#e74c3c",
                    color: "#fff",
                    borderRadius: "50%",
                    fontSize: "10px",
                    fontWeight: "bold",
                    minWidth: "18px",
                    height: "18px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "0 3px",
                    pointerEvents: "none",
                  }}
                >
                  {unreadCount > 99 ? "99+" : unreadCount}
                </span>
              )}
            </li>
            <li>
              <div className="nav-logo-box">
                <img src={logo} alt="logo" />
              </div>
            </li>
            <li>
              <i
                className="fas fa-globe"
                title={
                  lang === "en"
                    ? t("switchLanguage")
                    : t("switchLanguageToEnglish")
                }
                onClick={() => changeLanguage(lang === "en" ? "ar" : "en")}
              ></i>
            </li>
            <li>
              <i
                className="fas fa-power-off"
                title={t("logout")}
                data-bs-toggle="modal"
                data-bs-target="#logout-modal"
              ></i>
            </li>
            <li>
  <div
    className="provider-profile"
    title={providerName || "Provider"}
  >
    <div className="provider-avatar">
      <i className="fas fa-user"></i>
    </div>

    <span className="provider-name">
      {providerName?.split(" ")[0] || "Provider"}
    </span>
  </div>
</li>
          </ul>
        </nav>
      </header>
      {showNotifications && (
        <div ref={panelRef}>
          <Notification
            t={t}
            onMarkRead={decrementCount}
            onClose={() => setShowNotifications(false)}
          />
        </div>
      )}
      <LogoutConfirmation t={t} handleLogout={logout} />
    </>
  );
};

export default Header;
